import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProfileOption } from '../profile-sidebar/profile-sidebar.component';

@Component({
    selector: 'app-profile-content',
    templateUrl: './profile-content.component.html',
    styleUrls: ['./profile-content.component.scss']
})
export class ProfileContentComponent {

    @Input() active: ProfileOption = 'profile';
    @Input() profileData: any;
    @Input() paymentData: any;
    @Output() editClick = new EventEmitter<void>();

    get poliza(): string {
        if (this.paymentData && this.paymentData.length) {
            return this.paymentData[0].policyNumber || this.paymentData[0].number || '';
        }
        return '';
    }

    get cuentaBancaria(): string {
        if (this.paymentData && this.paymentData.length) {
            return this.paymentData[0].bankAccount || this.paymentData[0].iban || this.paymentData[0].account || '';
        }
        return '';
    }

    get tipoPago(): string {
        if (this.paymentData && this.paymentData.length) {
            return this.paymentData[0].periodicity || this.paymentData[0].paymentMethod || this.paymentData[0].paymentType || '';
        }
        return '';
    }

    onProfileAction(clickResult : any): void {
        console.log('Llega a profile-content:', clickResult);  // 👈 debug
        this.active = clickResult.section;
    }
}
